import type { MotionPreference } from "./settings";

let preference: MotionPreference = "system";

/** Applies the user's motion preference (also exposed to CSS as body[data-reduced-motion]). */
export function setMotionPreference(value: MotionPreference): void {
	preference = value;
	if (typeof document !== "undefined") {
		document.body.dataset.reducedMotion = String(prefersReducedMotion());
	}
}

/** The OS query, created once: rendering asks every frame (P10.13 profile: matchMedia per frame). */
let systemQuery: MediaQueryList | null | undefined;

/** Reduced motion: the explicit setting, or the operating system preference. */
export function prefersReducedMotion(): boolean {
	if (preference === "on") return true;
	if (preference === "off") return false;
	if (systemQuery === undefined) {
		systemQuery =
			typeof window !== "undefined" ? window.matchMedia("(prefers-reduced-motion: reduce)") : null;
	}
	return systemQuery?.matches === true;
}
